module.exports = __webpack_public_path__ + "img/multimedia-typing-guide.876c4af0.jpg";